import { isDate } from 'date-fns';
import i18n, { type Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { TimestampFormat, formatTimestamp } from './helpers/datetime';

function getI18NextResources(): Resource {
    // It may be better to refactor this into an i18next backend plugin
    const modules = import.meta.glob<string>('./translations/**/*.json', {
        eager: true,
        query: '?raw',
        import: 'default',
    });
    const resources: Resource = {};
    for (const filePath in modules) {
        const segments = filePath
            .replace(/^\.\//, '')
            .split('/')
            .map((s) => s.replace(/\.json$/, ''));
        const language = segments[1];
        resources[language] = resources[language] || {};
        const namespace = segments.length === 2 ? 'translation' : segments.slice(2).join('.');
        resources[language][namespace] = JSON.parse(modules[filePath]);
    }
    return resources;
}

export const configureI18Next = (): void => {
    // i18n is being added here only as a proof-of-concept.
    // TODO:
    // 1. Figure out a way to namespace the keys (e.g. "facilities.details.facilityDetails.provinceLabel").
    // 2. Add en-US translations where appropriate.
    void i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            // Our translation resources use i18next v4 plural keys (`*_one`, `*_other`), so we must
            // use v4 JSON compatibility. v3 mode ignores those keys.
            compatibilityJSON: 'v4',
            resources: getI18NextResources(),
            fallbackLng: 'en-CA',
            partialBundledLanguages: true,
            interpolation: {
                escapeValue: false,
                format: (value, _format) => {
                    if (isDate(value)) {
                        const idx = Object.keys(TimestampFormat).indexOf(_format || '');
                        const f = Object.values(TimestampFormat)[idx] ?? TimestampFormat.DATE;
                        return formatTimestamp(value, f);
                    }
                    return value;
                },
            },
            nsSeparator: false,
        });
};
